import React, { useEffect, useState, Children, Component } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Clock, Plus, Minus, Info, X, Calendar, Truck, MapPin, ShoppingBag, Trash2 } from 'lucide-react';
import { Button } from './ui/Button';
import { ServiceType } from './Navigation';
interface CateringCatalogProps {
  onOrderClick: (type: ServiceType) => void;
  businessOrderTrigger?: number;
}
const catalogData = [{
  category: 'Bullar',
  items: [{
    name: 'Kanelbulle',
    image: 'https://cdn.magicpatterns.com/uploads/hwcTF2GfMBWMf1YuqZ5h5u/image_10.png',
    description: 'Klassisk svensk kanelbulle med kanel, socker och kardemumma. Toppas med pärlsocker.'
  }, {
    name: 'Kardemumma bulle',
    image: 'https://cdn.magicpatterns.com/uploads/rEA8A9kv65fkpBp4so79L4/image_6.png',
    description: 'Mjuk vetedeg smaksatt med kardemumma, vikt och toppad med pärlsocker.'
  }, {
    name: 'Sockrad kardemumma bulle med vanilj fyllning',
    image: 'https://cdn.magicpatterns.com/uploads/sUjNTjcZYXjnSJ4pBC7d7n/image_7.png',
    description: 'Sockrad kardemummabulle fylld med krämig vaniljkräm. Mjuk och aromatisk.'
  }, {
    name: 'Kolabulle',
    image: 'https://cdn.magicpatterns.com/uploads/iqGFaHSzMboJ6yRGias7KE/image_4.png',
    description: 'Söt bulle fylld med hemgjord kolasmör. Mjuk och kladdig.'
  }, {
    name: 'Wiernerbröd - smak kan variera',
    image: 'https://cdn.magicpatterns.com/uploads/ms5qNpDtoKYKw4yDu8smSF/image_10.png',
    description: 'Flaky wienerdeg fylld med kolakräm och toppat med söt glasyr.'
  }, {
    name: 'Banoffee bulle med choklad och havresmul',
    image: 'https://cdn.magicpatterns.com/uploads/appg4NNekEnFadYTPq7JVT/image_8.png',
    description: 'Kreativ bulle inspirerad av banoffee pie – med banan, choklad och krispig havresmul.'
  }, {
    name: 'Birkes med lite mandelfyllning',
    image: 'https://cdn.magicpatterns.com/uploads/dEKG1snmX55KP9wqTu3DQC/image_7.png',
    description: 'Dansk birkes i smördeg med en lätt mandelfyllning inuti.'
  }]
}, {
  category: 'Choklad',
  items: [{
    name: 'Chokladboll med pärlsocker',
    image: 'https://cdn.magicpatterns.com/uploads/kxYvUqLMq1ZUBfKUi9acni/image_1.png',
    description: 'Klassisk chokladboll rullad i pärlsocker. Gjord på havregryn, kakao och smör.'
  }, {
    name: 'Chokladboll med kokos',
    image: 'https://cdn.magicpatterns.com/uploads/nkZJuarzFjL2q1sAf73cSB/image_2.png',
    description: 'Traditionell chokladboll rullad i kokos istället för pärlsocker.'
  }, {
    name: 'Chokladbar',
    image: 'https://cdn.magicpatterns.com/uploads/3qu6qPQX1n2aEe1CorJUYX/image_1.png',
    description: 'Kompakt chokladbar med rik chokladsmak. Perfekt till fikat.'
  }, {
    name: 'Chocolate chip & cookie dough bar',
    image: 'https://cdn.magicpatterns.com/uploads/7EyJLhF69KvJZCW4iWizvP/image_2.png',
    description: 'Amerikansk-inspirerad bar med cookie dough och chocolate chips.'
  }, {
    name: 'Mörk choklad & hallon bar',
    image: 'https://cdn.magicpatterns.com/uploads/5wPaNtL3Ta12H5fToe57yh/image_3.png',
    description: 'Intensiv mörk choklad kombinerad med syrliga hallon.'
  }, {
    name: 'Nöt & mjölkchoklad bar',
    image: 'https://cdn.magicpatterns.com/uploads/kvNw4SWykoJ1wcp53hBzsY/image_4.png',
    description: 'Krämig mjölkchoklad med knapriga nötter.'
  }, {
    name: 'Chokladbiskvi med havssalt',
    image: 'https://cdn.magicpatterns.com/uploads/eDvgtKwdWN3CdQHLnCh64V/image_5.png',
    description: 'Klassisk biskvi med chokladöverdrag och en touch av havssalt.'
  }]
}, {
  category: 'Bakelser',
  items: [{
    name: 'Chokladbakelse - fyllning kan variera',
    image: 'https://cdn.magicpatterns.com/uploads/nMnXnEyAyUwCAmWF17BxD2/image_3.png',
    description: 'Lyxig chokladbakelse – fyllningen varierar efter säsong.'
  }, {
    name: 'Morotskaka',
    image: 'https://cdn.magicpatterns.com/uploads/pXzUCx2ewaUkHRhBSRwXBz/image_4.png',
    description: 'Saftig morotskaka med kryddor, valnötter och frosting.'
  }, {
    name: 'Morotstårta',
    image: 'https://cdn.magicpatterns.com/uploads/oDp2AmoRR2zEmY1SFp12Ut/image_7.png',
    description: 'Generös morotstårta med krämig frosting – perfekt att dela.'
  }, {
    name: 'Cheesecake - smak kan variera veckovis',
    image: 'https://cdn.magicpatterns.com/uploads/x9hQsb7YhedcDdS7pVEh5p/image_1.png',
    description: 'Krämig cheesecake på digestivebotten. Smaken varierar veckovis.'
  }, {
    name: 'Sockermunk',
    image: 'https://cdn.magicpatterns.com/uploads/gr18rB2X5A1DoHmc9rxLcD/image_2.png',
    description: 'Klassisk friterad munk rullad i socker. Mjuk och luftig.'
  }, {
    name: 'Chokladmunk med hallon',
    image: 'https://cdn.magicpatterns.com/uploads/nHkuCnKZRft85EMTNinMJu/image_3.png',
    description: 'Chokladdoppad munk fylld med hallonkräm.'
  }]
}, {
  category: 'Frukost',
  items: [{
    name: 'Overnight oats med chia, mango & rostad kokos',
    image: 'https://cdn.magicpatterns.com/uploads/btDCBM4zYfDosX7Cjoz5sJ/image_5.png',
    description: 'Krämig overnight oats med chia, toppad med färsk mango och rostad kokos.'
  }, {
    name: 'Yoghurt med granola',
    image: 'https://cdn.magicpatterns.com/uploads/5PaXYLwJS6HSDBeamYcTEg/image_8.png',
    description: 'Naturell yoghurt serverad med hemgjord knaprig granola.'
  }, {
    name: 'Frukostpaket – ost',
    image: 'https://cdn.magicpatterns.com/uploads/j5huTsc5D8GTc48z7Mi9vA/image_4.png',
    description: 'Komplett frukostpaket med ostmacka, juice och tillbehör.'
  }, {
    name: 'Frukostpaket – salami & brie, juice, chiapudding',
    image: 'https://cdn.magicpatterns.com/uploads/oaqcoRs7AtqqsBfzp9qQiv/image_5.png',
    description: 'Lyxigt frukostpaket med salami & brie-macka, juice och chiapudding.'
  }, {
    name: 'Frukostpaket – yoghurt, äppeljuice, ost& skinka macka',
    image: 'https://cdn.magicpatterns.com/uploads/uWGdM1CqdWDFTBdzCXbCKF/image_8.png',
    description: 'Varierat frukostpaket med yoghurt, äppeljuice och ost & skinka-macka.'
  }, {
    name: '1 x apelsinjuice\n1 x äppeljuice',
    image: 'https://cdn.magicpatterns.com/uploads/f3cW3ZnbGbtZBrnktdSbX4/image_9.png',
    description: 'Två flaskor nypressad juice – en apelsin och en äpple.'
  }, {
    name: '1 x bärsmoothie\n1 x tropisk smoothie',
    image: 'https://cdn.magicpatterns.com/uploads/atFVZdziLQaRrp7qC1N2ak/image_10.png',
    description: 'Två smoothies – en med bär och en tropisk.'
  }, {
    name: 'Bärsmoothie - Acai, jordgubb, blåbär\nKan variera i smak månadsvis. Görs på frukt och äppeljuice.',
    image: 'https://cdn.magicpatterns.com/uploads/2Bf39hYWMB4MJJ3DK1n8Pn/image_1.png',
    description: 'Smoothie gjord på acai, jordgubb och blåbär med äppeljuice som bas.'
  }, {
    name: 'Tropisk smoothie - Ananas, Mango, Passion\nGörs på frukt och äppleljuice som bas',
    image: 'https://cdn.magicpatterns.com/uploads/g59kb85GwBq2saoXYoMuYp/image_2.png',
    description: 'Fruktig smoothie med ananas, mango och passion. Görs på äppeljuice som bas.'
  }, {
    name: 'Apelsinjuice',
    image: 'https://cdn.magicpatterns.com/uploads/gfrmVeQToRRqoSF2kVxzTi/apelsin.png',
    description: 'Nypressad apelsinjuice.'
  }, {
    name: 'Äppeljuice',
    image: 'https://cdn.magicpatterns.com/uploads/qWL7Ry5cDHi6NTYhGVb8kd/image_3.png',
    description: 'Nypressad äppeljuice.'
  }]
}, {
  category: 'Frallor & Mackor',
  items: [{
    name: 'Surdegs vete frallor',
    image: 'https://cdn.magicpatterns.com/uploads/5p2XyheDPdYKpSonQJEdex/image_6.png',
    description: 'Nybakade surdegsvetefrallor med fin skorpa och mjukt inkråm.'
  }, {
    name: 'Surdegs vete fralla med herrgårdsost',
    image: 'https://cdn.magicpatterns.com/uploads/vZNCZqnv4HBxqt7agYGMai/image_5.png',
    description: 'Surdegsvetefralla gratinerad med herrgårdsost.'
  }, {
    name: 'Surdegs levain',
    image: 'https://cdn.magicpatterns.com/uploads/69haLdNUMuUxQKdTCHdGCm/image_6.png',
    description: 'Rustikt surdegsbröd bakat på lång jäsning för djup smak.'
  }, {
    name: 'Salami & brie macka',
    image: 'https://cdn.magicpatterns.com/uploads/wRdWtzxiF5fpCS6BK2bJMJ/image_6.png',
    description: 'Macka med salami och krämig brie på nybakat bröd.'
  }, {
    name: 'Skinkmacka med juice',
    image: 'https://cdn.magicpatterns.com/uploads/hKJQfb623CnqfR7BupQvSJ/image_7.png',
    description: 'Klassisk skinkmacka serverad med en juice.'
  }, {
    name: 'Blandad Trio\n1x Skinka & ost\n1x Salami & brie\n1x Ost x Grönt',
    image: 'https://cdn.magicpatterns.com/uploads/h8cz3nyPrv94AoTdNFyfEG/image_9.png',
    description: 'Tre mackor i en – skinka & ost, salami & brie, samt ost & grönt.'
  }]
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: 'easeOut'
    }
  }
};
export function CateringCatalog({
  onOrderClick,
  businessOrderTrigger
}: CateringCatalogProps) {
  const [quantities, setQuantities] = useState<Record<string, number>>({});
  const [selectedProduct, setSelectedProduct] = useState<{
    name: string;
    image: string;
    description: string;
  } | null>(null);
  const [isCartOpen, setIsCartOpen] = useState(false);
  const [orderDate, setOrderDate] = useState('');
  const [orderTime, setOrderTime] = useState('');
  const [deliveryType, setDeliveryType] = useState<'avhämtning' | 'upphämtning'>('avhämtning');
  const [customerType, setCustomerType] = useState<'företag' | 'privatperson'>('företag');
  const [orderFrequency, setOrderFrequency] = useState<'engång' | 'återkommande'>('engång');
  const [deliveryStreet, setDeliveryStreet] = useState('');
  const [deliveryPostalCode, setDeliveryPostalCode] = useState('');
  const [deliveryCity, setDeliveryCity] = useState('');
  const [companyName, setCompanyName] = useState('');
  const [contactPerson, setContactPerson] = useState('');
  const [customerEmail, setCustomerEmail] = useState('');
  const [customerPhone, setCustomerPhone] = useState('');
  const [orderTimeTo, setOrderTimeTo] = useState('');
  const [exactTime, setExactTime] = useState(false);
  const [recurringType, setRecurringType] = useState<'veckovis' | 'månadsvis' | 'annat'>('veckovis');
  const [selectedWeekdays, setSelectedWeekdays] = useState<string[]>([]);
  const [selectedMonthDates, setSelectedMonthDates] = useState<number[]>([]);
  const [recurringNote, setRecurringNote] = useState('');
  const [orgNumber, setOrgNumber] = useState('');
  const [invoiceEmail, setInvoiceEmail] = useState('');
  const [invoiceReference, setInvoiceReference] = useState('');
  const [önskemål, setÖnskemål] = useState('');
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [showBusinessBanner, setShowBusinessBanner] = useState(false);
  useEffect(() => {
    if (businessOrderTrigger && businessOrderTrigger > 0) {
      setCustomerType('företag');
      setShowBusinessBanner(true);
      // Auto-dismiss after 8 seconds
      const timer = setTimeout(() => setShowBusinessBanner(false), 8000);
      return () => clearTimeout(timer);
    }
  }, [businessOrderTrigger]);
  const toggleWeekday = (day: string) => {
    setSelectedWeekdays(prev => prev.includes(day) ? prev.filter(d => d !== day) : [...prev, day]);
  };
  const toggleMonthDate = (date: number) => {
    setSelectedMonthDates(prev => prev.includes(date) ? prev.filter(d => d !== date) : [...prev, date]);
  };
  const handleQuantityChange = (productName: string, delta: number) => {
    setQuantities(prev => {
      const current = prev[productName] || 0;
      const next = Math.max(0, current + delta);
      if (next === 0) {
        const newQuantities = {
          ...prev
        };
        delete newQuantities[productName];
        return newQuantities;
      }
      return {
        ...prev,
        [productName]: next
      };
    });
  };
  const totalItems = Object.values(quantities).reduce((sum, q) => sum + q, 0);
  // Helper to get product details for the cart
  const getSelectedItemsDetails = () => {
    const items: {
      name: string;
      image: string;
      quantity: number;
    }[] = [];
    catalogData.forEach(section => {
      section.items.forEach(item => {
        if (quantities[item.name]) {
          items.push({
            ...item,
            quantity: quantities[item.name]
          });
        }
      });
    });
    return items;
  };
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState('');
  const [fieldErrors, setFieldErrors] = useState<Record<string, string>>({});
  const isValidEmail = (email: string) => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email.trim());
  const isValidPhone = (phone: string) => {
    const digits = phone.replace(/[\s\-\(\)]/g, '');
    return /^(\+?46|0)\d{7,10}$/.test(digits);
  };
  const isValidPostalCode = (code: string) => /^\d{3}\s?\d{2}$/.test(code.trim());
  const isValidOrgNumber = (org: string) => /^\d{6}[\-\s]?\d{4}$/.test(org.trim());
  const validateForm = (): boolean => {
    const errors: Record<string, string> = {};
    // Common validations
    if (!contactPerson.trim()) errors.contactPerson = 'Namn krävs';
    if (!customerEmail.trim()) {
      errors.customerEmail = 'E-post krävs';
    } else if (!isValidEmail(customerEmail)) {
      errors.customerEmail = 'Ogiltig e-postadress';
    }
    if (!customerPhone.trim()) {
      errors.customerPhone = 'Telefon krävs';
    } else if (!isValidPhone(customerPhone)) {
      errors.customerPhone = 'Ogiltigt telefonnummer (t.ex. 070-123 45 67)';
    }
    if (!orderDate) errors.orderDate = 'Datum krävs';
    if (!orderTime) errors.orderTime = 'Tid krävs';
    if (totalItems === 0) errors.products = 'Välj minst en produkt';
    // Företag-specific
    if (customerType === 'företag') {
      if (!companyName.trim()) errors.companyName = 'Företagsnamn krävs';
      if (!orgNumber.trim()) {
        errors.orgNumber = 'Organisationsnummer krävs';
      } else if (!isValidOrgNumber(orgNumber)) {
        errors.orgNumber = 'Ogiltigt format (XXXXXX-XXXX)';
      }
      if (!invoiceEmail.trim()) {
        errors.invoiceEmail = 'Fakturamejl krävs';
      } else if (!isValidEmail(invoiceEmail)) {
        errors.invoiceEmail = 'Ogiltig e-postadress';
      }
      if (!invoiceReference.trim()) errors.invoiceReference = 'Referens krävs';
      // Delivery address validation
      if (deliveryType === 'upphämtning') {
        if (!deliveryStreet.trim()) errors.deliveryStreet = 'Gatuadress krävs';
        if (!deliveryPostalCode.trim()) {
          errors.deliveryPostalCode = 'Postnummer krävs';
        } else if (!isValidPostalCode(deliveryPostalCode)) {
          errors.deliveryPostalCode = 'Ogiltigt postnummer (t.ex. 123 45)';
        }
        if (!deliveryCity.trim()) errors.deliveryCity = 'Ort krävs';
      }
    }
    setFieldErrors(errors);
    return Object.keys(errors).length === 0;
  };
  const handleContinue = async () => {
    if (!validateForm()) return;
    setIsSubmitting(true);
    setSubmitError('');
    // Build product summary: "Kanelbulle x3, Morotskaka x2"
    const productSummary = getSelectedItemsDetails().map(item => `${item.name} x${item.quantity}`).join(', ');
    // Build recurring schedule description
    let recurringDescription = '';
    if (orderFrequency === 'återkommande') {
      if (recurringType === 'veckovis') {
        recurringDescription = `Veckovis: ${selectedWeekdays.join(', ') || '–'}`;
      } else if (recurringType === 'månadsvis') {
        recurringDescription = `Månadsvis: datum ${selectedMonthDates.sort((a, b) => a - b).join(', ') || '–'}`;
      } else {
        recurringDescription = `Annat: ${recurringNote || '–'}`;
      }
    }
    const fullAddress = deliveryType === 'upphämtning' ? `${deliveryStreet}, ${deliveryPostalCode} ${deliveryCity}` : '';
    // Generate unique order/customer number: TNB-F-YYYYMMDD-XXXX or TNB-P-...
    const now = new Date();
    const dateStr = now.toISOString().slice(0, 10).replace(/-/g, '');
    const randomId = Math.random().toString(36).substring(2, 6).toUpperCase();
    const orderPrefix = customerType === 'företag' ? 'F' : 'P';
    const kundnummer = `TNB-${orderPrefix}-${dateStr}-${randomId}`;
    const tidsstämpel = now.toLocaleString('sv-SE');
    // Separate payloads for företag vs privatperson
    // Prio columns first: kundnummer, contact, products, date/time — then details
    const företagPayload = {
      data: [{
        Kundnummer: kundnummer,
        Tidsstämpel: tidsstämpel,
        // === PRIO: Kontakt & Beställning ===
        Kontaktperson: contactPerson,
        Epost: customerEmail,
        Telefon: customerPhone,
        Produkter: productSummary,
        Antal_produkter: totalItems.toString(),
        Datum: orderDate,
        Tid_från: orderTime,
        Tid_till: orderTimeTo || '–',
        Exakt_tid: exactTime ? 'Ja' : 'Nej',
        // === Företagsuppgifter ===
        Företagsnamn: companyName,
        Organisationsnummer: orgNumber,
        Fakturamejl: invoiceEmail,
        Referens: invoiceReference,
        Önskemål: önskemål || '–',
        // === Leverans ===
        Leveranssätt: deliveryType === 'upphämtning' ? 'Utkörning' : 'Avhämtning',
        Gatuadress: deliveryType === 'upphämtning' ? deliveryStreet : '–',
        Postnummer: deliveryType === 'upphämtning' ? deliveryPostalCode : '–',
        Ort: deliveryType === 'upphämtning' ? deliveryCity : '–',
        Full_adress: fullAddress || '–',
        Google_Maps: fullAddress ? `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}` : '–',
        // === Återkommande ===
        Ordertyp: orderFrequency,
        Återkommande_schema: recurringDescription || '–',
        Status: 'Ny'
      }]
    };
    const privatPayload = {
      data: [{
        Kundnummer: kundnummer,
        Tidsstämpel: tidsstämpel,
        // === PRIO: Kontakt & Beställning ===
        Namn: contactPerson,
        Epost: customerEmail,
        Telefon: customerPhone,
        Produkter: productSummary,
        Antal_produkter: totalItems.toString(),
        Datum: orderDate,
        Avhämtningstid: orderTime,
        // === Övrigt ===
        Status: 'Ny'
      }]
    };
    const payload = customerType === 'företag' ? företagPayload : privatPayload;
    // Build clear, scannable email for order@topnotchbakery.se
    const typeLabel = customerType === 'företag' ? '🏢 FÖRETAG' : '👤 PRIVAT';
    const leveransLabel = customerType === 'företag' ? deliveryType === 'upphämtning' ? '🚚 Utkörning' : '📍 Avhämtning' : '📍 Avhämtning i butik';
    const tidLabel = orderTime + (orderTimeTo ? ` – ${orderTimeTo}` : '') + (exactTime ? ' (EXAKT TID)' : '');
    const emailSubject = `[${kundnummer}] ${typeLabel} – ${customerType === 'företag' ? companyName : contactPerson} – ${orderDate} kl ${orderTime}`;
    const emailLines = [`════════════════════════════════`, `   ORDERNUMMER: ${kundnummer}`, `════════════════════════════════`, '', `▸ TYP:        ${typeLabel}`, `▸ DATUM:      ${orderDate}`, `▸ TID:        ${tidLabel}`, `▸ LEVERANS:   ${leveransLabel}`, '', `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `   PRODUKTER`, `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`];
    // List each product on its own line
    getSelectedItemsDetails().forEach(item => {
      emailLines.push(`  • ${item.name}  ×${item.quantity}`);
    });
    emailLines.push(`  ─────────────────`);
    emailLines.push(`  Totalt: ${totalItems} st`);
    emailLines.push('', `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `   KONTAKTUPPGIFTER`, `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `  Namn:     ${contactPerson}`, `  E-post:   ${customerEmail}`, `  Telefon:  ${customerPhone}`);
    if (customerType === 'företag') {
      emailLines.push('', `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `   FÖRETAGSUPPGIFTER`, `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `  Företag:  ${companyName}`, `  Org.nr:   ${orgNumber}`, `  Faktura:  ${invoiceEmail}`, `  Referens: ${invoiceReference}`, `  Önskemål: ${önskemål || '–'}`);
      if (deliveryType === 'upphämtning') {
        emailLines.push('', `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `   LEVERANSADRESS`, `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `  ${deliveryStreet}`, `  ${deliveryPostalCode} ${deliveryCity}`, `  📍 Google Maps: https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(fullAddress)}`);
      }
      if (orderFrequency === 'återkommande' && recurringDescription) {
        emailLines.push('', `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `   ÅTERKOMMANDE`, `━━━━━━━━━━━━━━━━━━━━━━━━━━━━━━`, `  ${recurringDescription}`);
      }
    }
    emailLines.push('', `════════════════════════════════`, `Svara direkt på detta mejl för att nå kunden.`, `════════════════════════════════`);
    const emailPayload = {
      access_key: 'c9228efa-9300-46fa-a21c-050430afdc38',
      subject: emailSubject,
      from_name: `Top Notch Order – ${contactPerson}`,
      replyto: customerEmail,
      message: emailLines.join('\n')
    };
    try {
      const SHEETDB_FORETAG = 'https://sheetdb.io/api/v1/3muzfomk6jlmo';
      const SHEETDB_PRIVAT = 'https://sheetdb.io/api/v1/fuu0y5q39q2rc';
      const SHEETDB_URL = customerType === 'företag' ? SHEETDB_FORETAG : SHEETDB_PRIVAT;
      // Send to SheetDB and email in parallel
      const [sheetRes] = await Promise.all([fetch(SHEETDB_URL, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(payload)
      }), fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(emailPayload)
      })]);
      if (!sheetRes.ok) throw new Error('Kunde inte skicka förfrågan');
      setIsSubmitted(true);
    } catch (err) {
      setSubmitError('Något gick fel. Försök igen eller mejla order@topnotchbakery.se');
    } finally {
      setIsSubmitting(false);
    }
  };
  return <section id="catalog" className="w-full pt-4 pb-24 relative" data-id="element-20">
      {/* Business order banner */}
      <AnimatePresence data-id="element-21">
        {showBusinessBanner && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -10
      }} transition={{
        duration: 0.4
      }} className="max-w-3xl mx-auto mb-8 px-4" data-id="element-22">
            <div className="flex items-center gap-3 p-4 bg-[#C4993D]/10 border border-[#C4993D]/30 rounded-xl" data-id="element-23">
              <span className="text-2xl" data-id="element-24">🏢</span>
              <div className="flex-1" data-id="element-25">
                <p className="text-sm font-semibold text-[#1A1A1A]" data-id="element-26">
                  Företagsbeställning
                </p>
                <p className="text-sm text-[#1A1A1A]/70" data-id="element-27">
                  Välj produkter nedan och klicka "Granska förfrågan" när du är
                  klar. Företag är förvalt som kundtyp.
                </p>
              </div>
              <button onClick={() => setShowBusinessBanner(false)} className="p-1.5 text-[#1A1A1A]/40 hover:text-[#1A1A1A] rounded-full hover:bg-white/50 transition-colors" data-id="element-28">
                <X className="w-4 h-4" data-id="element-29" />
              </button>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Order contact email */}
      <div className="max-w-2xl mx-auto mb-10 px-4" data-id="element-30">
        <div className="flex items-center gap-3 p-4 bg-white rounded-xl border border-[#7C8062]/15 shadow-sm" data-id="element-31">
          <span className="text-xl" data-id="element-32">📧</span>
          <div className="text-sm text-[#1A1A1A]/80" data-id="element-33">
            <span data-id="element-34">Frågor om beställningar? Kontakta oss på </span>
            <a href="mailto:order@topnotchbakery.se" className="text-[#7C8062] font-semibold underline underline-offset-2 hover:text-[#6A6D53] transition-colors" data-id="element-35">
              order@topnotchbakery.se
            </a>
          </div>
        </div>
      </div>

      <div className="text-center mb-16 px-4" data-id="element-36">
        <h2 className="text-4xl md:text-5xl font-serif text-[#1A1A1A] mb-4" data-id="element-37">
          Vårt Stående Utbud
        </h2>
        <p className="text-[#1A1A1A]/70 max-w-xl mx-auto mb-3 text-base" data-id="element-38">
          Välj produkter nedan och fyll i era uppgifter för att skicka en
          offertförfrågan. Klicka på produkterna för näringsinnehåll.
        </p>
        <p className="text-[#1A1A1A]/50 max-w-xl mx-auto mb-8 text-sm italic" data-id="element-39">
          Utöver detta finns fler alternativ i vår 8 meter långa disk på plats —
          i mån av tillgänglighet.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3" data-id="element-40">
          <div className="inline-flex items-center gap-2.5 px-5 py-2.5 bg-[#7C8062]/10 rounded-full border border-[#7C8062]/20" data-id="element-41">
            <Clock className="w-4 h-4 text-[#7C8062]" data-id="element-42" />
            <span className="text-sm font-medium text-[#1A1A1A]/80" data-id="element-43">
              Vi svarar på alla förfrågningar inom 24 timmar
            </span>
          </div>
          <div className="inline-flex items-center gap-2.5 px-5 py-2.5 bg-[#F2EDE4] rounded-full border border-[#7C8062]/20" data-id="element-44">
            <span className="text-base leading-none" data-id="element-45">🥛</span>
            <span className="text-sm font-medium text-[#1A1A1A]/80" data-id="element-46">
              Vi använder laktosfritt smör och laktosfri grädde i grunden.
              Fyllningar kan variera.
            </span>
          </div>
        </div>
      </div>

      <div className="space-y-16 px-4 md:px-8 max-w-7xl mx-auto" data-id="element-47">
        {catalogData.map(section => <div key={section.category} data-id="element-48">
            <h3 className="text-2xl md:text-3xl font-serif text-[#1A1A1A] mb-8 flex items-center gap-4" data-id="element-49">
              {section.category}
              <div className="h-px bg-[#7C8062]/20 flex-1 mt-2" data-id="element-50" />
            </h3>

            <motion.div variants={containerVariants} initial="hidden" whileInView="show" viewport={{
          once: true,
          margin: '-50px'
        }} className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6" data-id="element-51">
              {section.items.length > 0 ? section.items.map((item, idx) => {
            const quantity = quantities[item.name] || 0;
            return <motion.div key={idx} variants={itemVariants} className={`${`group flex flex-col gap-3 p-3 rounded-2xl transition-all duration-300 ${quantity > 0 ? 'bg-[#F2EDE4] border-[#7C8062]/30 shadow-sm' : 'bg-white border-transparent hover:border-[#7C8062]/20'} border`} items-start justify-start`} data-id="element-52">
                      <div className="aspect-square md:aspect-[4/5] rounded-xl overflow-hidden bg-white border border-[#7C8062]/10 relative shadow-sm cursor-pointer" onClick={() => setSelectedProduct(item)} data-id="element-53">
                        <img src={item.image} alt={item.name} className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105" data-id="element-54" />
                        <div className="absolute inset-0 bg-black/0 group-hover:bg-black/5 transition-colors duration-300 flex items-center justify-center" data-id="element-55">
                          <div className="opacity-0 group-hover:opacity-100 bg-white/90 text-[#1A1A1A] text-xs font-medium px-3 py-1.5 rounded-full flex items-center gap-1.5 transition-opacity duration-300 transform translate-y-2 group-hover:translate-y-0" data-id="element-56">
                            <Info className="w-3.5 h-3.5" data-id="element-57" /> Info
                          </div>
                        </div>
                      </div>

                      <div className="flex flex-col flex-1 justify-between gap-3" data-id="element-58">
                        <div className="text-center" data-id="element-59">
                          <p className="text-sm md:text-base font-medium text-[#1A1A1A] leading-snug whitespace-pre-line" data-id="element-60">
                            {item.name}
                          </p>
                        </div>

                        <div className="flex items-center justify-center gap-3 bg-gray-50/50 rounded-lg p-1.5 border border-gray-100" data-id="element-61">
                          <button onClick={() => handleQuantityChange(item.name, -1)} disabled={quantity === 0} className={`w-8 h-8 rounded-md flex items-center justify-center transition-colors ${quantity > 0 ? 'bg-white text-[#1A1A1A] shadow-sm hover:bg-gray-50 border border-gray-200' : 'text-gray-300 cursor-not-allowed'}`} data-id="element-62">
                            <Minus className="w-4 h-4" data-id="element-63" />
                          </button>
                          <span className="w-6 text-center font-medium text-[#1A1A1A]" data-id="element-64">
                            {quantity}
                          </span>
                          <button onClick={() => handleQuantityChange(item.name, 1)} className="w-8 h-8 rounded-md bg-white text-[#1A1A1A] shadow-sm hover:bg-gray-50 border border-gray-200 flex items-center justify-center transition-colors" data-id="element-65">
                            <Plus className="w-4 h-4" data-id="element-66" />
                          </button>
                        </div>
                      </div>
                    </motion.div>;
          }) : <motion.div variants={itemVariants} className="flex flex-col gap-4" data-id="element-67">
                  <div className="aspect-square md:aspect-[4/5] rounded-2xl border-2 border-dashed border-[#7C8062]/20 bg-[#F2EDE4]/50 flex flex-col items-center justify-center gap-3 p-4 text-center" data-id="element-68">
                    <span className="text-4xl md:text-5xl" data-id="element-69">🥖</span>
                    <p className="text-sm md:text-base font-medium text-[#1A1A1A]/50" data-id="element-70">
                      Kommer snart
                    </p>
                  </div>
                </motion.div>}
            </motion.div>
          </div>)}
      </div>

      {/* OBS Reminder - above bottom bar */}
      <div className="max-w-7xl mx-auto px-4 md:px-8 mt-12 mb-28" data-id="element-71">
        <div className="flex items-start gap-3 p-4 bg-[#F2EDE4] rounded-xl border border-[#7C8062]/20" data-id="element-72">
          <Info className="w-5 h-5 text-[#7C8062] shrink-0 mt-0.5" data-id="element-73" />
          <div className="text-sm text-[#1A1A1A]/70" data-id="element-74">
            <p data-id="element-75">
              <span className="font-semibold text-[#1A1A1A]/90" data-id="element-76">OBS:</span> Alla
              beställningar är förfrågningar. Var ute minst 3 dagar i förväg så
              att vi hinner hantera er volym.
            </p>
            <p className="mt-2" data-id="element-77">
              Har du frågor? Kontakta oss på{' '}
              <a href="mailto:order@topnotchbakery.se" className="text-[#7C8062] font-medium underline underline-offset-2 hover:text-[#6A6D53] transition-colors" data-id="element-78">
                order@topnotchbakery.se
              </a>
            </p>
          </div>
        </div>
      </div>

      {/* Order Summary Bottom Bar — only visible when items are selected */}
      <AnimatePresence data-id="element-79">
        {totalItems > 0 && <motion.div initial={{
        y: '100%'
      }} animate={{
        y: 0
      }} exit={{
        y: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed bottom-0 left-0 right-0 bg-white border-t border-[#7C8062]/15 shadow-[0_-10px_40px_rgba(0,0,0,0.03)] z-30" data-id="element-80">
            <div className="max-w-7xl mx-auto px-4 py-4 md:py-6 flex flex-col md:flex-row items-center justify-between gap-6" data-id="element-81">
              <div className="flex flex-col sm:flex-row items-center gap-4 md:gap-8 w-full md:w-auto" data-id="element-82">
                <button onClick={() => setIsCartOpen(true)} className="flex items-center gap-3 bg-[#F2EDE4] px-4 py-2 rounded-xl border border-[#7C8062]/20 hover:bg-[#7C8062]/10 transition-colors cursor-pointer" data-id="element-83">
                  <ShoppingBag className="w-6 h-6 text-[#7C8062]" data-id="element-84" />
                  <div className="text-left" data-id="element-85">
                    <p className="text-xs text-[#1A1A1A]/60 font-medium" data-id="element-86">
                      Visa kundvagn
                    </p>
                    <p className="text-lg font-serif text-[#1A1A1A]" data-id="element-87">
                      {totalItems} st valda
                    </p>
                  </div>
                </button>

                <div className="flex flex-wrap items-center gap-3 w-full sm:w-auto hidden lg:flex" data-id="element-88">
                  <div className="relative flex-1 sm:flex-none" data-id="element-89">
                    <input type="date" value={orderDate} onChange={e => setOrderDate(e.target.value)} className="w-full h-11 pl-10 pr-4 rounded-lg border border-[#7C8062]/20 bg-white focus:border-[#7C8062] focus:ring-2 focus:ring-[#7C8062]/20 outline-none transition-all text-sm" data-id="element-90" />
                    <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#1A1A1A]/40 pointer-events-none" data-id="element-91" />
                  </div>
                  <div className="relative flex-1 sm:flex-none" data-id="element-92">
                    <input type="time" value={orderTime} onChange={e => setOrderTime(e.target.value)} className="w-full h-11 pl-10 pr-4 rounded-lg border border-[#7C8062]/20 bg-white focus:border-[#7C8062] focus:ring-2 focus:ring-[#7C8062]/20 outline-none transition-all text-sm" data-id="element-93" />
                    <Clock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#1A1A1A]/40 pointer-events-none" data-id="element-94" />
                  </div>
                </div>

                <div className="flex items-center bg-gray-50 p-1 rounded-lg w-full sm:w-auto hidden lg:flex border border-gray-100" data-id="element-95">
                  <button onClick={() => setDeliveryType('avhämtning')} className={`flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${deliveryType === 'avhämtning' ? 'bg-white text-[#1A1A1A] shadow-sm' : 'text-[#1A1A1A]/60 hover:text-[#1A1A1A]'}`} data-id="element-96">
                    <MapPin className="w-4 h-4" data-id="element-97" />
                    Avhämtning
                  </button>
                  <button onClick={() => setDeliveryType('upphämtning')} className={`flex-1 sm:flex-none flex items-center justify-center gap-2 px-4 py-2 rounded-md text-sm font-medium transition-all ${deliveryType === 'upphämtning' ? 'bg-white text-[#1A1A1A] shadow-sm' : 'text-[#1A1A1A]/60 hover:text-[#1A1A1A]'}`} data-id="element-98">
                    <Truck className="w-4 h-4" data-id="element-99" />
                    Utkörning
                  </button>
                </div>
              </div>

              <Button onClick={() => setIsCartOpen(true)} disabled={totalItems === 0} className="w-full md:w-auto min-w-[220px] py-3.5 text-base shadow-sm" data-id="element-100">
                Granska förfrågan
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>

      {/* Slide-in Cart Sidebar */}
      <AnimatePresence data-id="element-101">
        {isCartOpen && <>
            <motion.div initial={{
          opacity: 0
        }} animate={{
          opacity: 1
        }} exit={{
          opacity: 0
        }} className="fixed inset-0 bg-black/20 backdrop-blur-sm z-40" onClick={() => setIsCartOpen(false)} data-id="element-102" />
            <motion.div initial={{
          x: '100%'
        }} animate={{
          x: 0
        }} exit={{
          x: '100%'
        }} transition={{
          type: 'spring',
          damping: 25,
          stiffness: 200
        }} className="fixed top-0 right-0 bottom-0 w-full max-w-md bg-white shadow-2xl z-50 flex flex-col" data-id="element-103">
              <div className="p-6 border-b border-[#7C8062]/15 flex items-center justify-between bg-[#F2EDE4]/50" data-id="element-104">
                <div className="flex items-center gap-3" data-id="element-105">
                  <ShoppingBag className="w-6 h-6 text-[#7C8062]" data-id="element-106" />
                  <h2 className="text-2xl font-serif text-[#1A1A1A]" data-id="element-107">
                    Offert Kundvagn
                  </h2>
                </div>
                <button onClick={() => setIsCartOpen(false)} className="p-2 text-gray-400 hover:text-[#1A1A1A] hover:bg-white rounded-full transition-colors" data-id="element-108">
                  <X className="w-6 h-6" data-id="element-109" />
                </button>
              </div>

              <div className="flex-1 overflow-y-auto p-6 space-y-4" data-id="element-110">
                {totalItems === 0 ? <div className="h-full flex flex-col items-center justify-center text-center space-y-4 text-[#1A1A1A]/50" data-id="element-111">
                    <ShoppingBag className="w-16 h-16 text-[#7C8062]/30" data-id="element-112" />
                    <p data-id="element-113">
                      Din kundvagn är tom.
                      <br data-id="element-114" />
                      Lägg till produkter från utbudet.
                    </p>
                  </div> : getSelectedItemsDetails().map((item, idx) => <motion.div layout initial={{
              opacity: 0,
              y: 10
            }} animate={{
              opacity: 1,
              y: 0
            }} key={item.name} className="flex items-center gap-4 p-3 bg-white border border-[#7C8062]/15 rounded-xl shadow-sm" data-id="element-115">
                      <img src={item.image} alt={item.name} className="w-16 h-16 rounded-lg object-cover border border-[#7C8062]/10" data-id="element-116" />
                      <div className="flex-1 min-w-0" data-id="element-117">
                        <p className="text-sm font-medium text-[#1A1A1A] truncate" data-id="element-118">
                          {item.name}
                        </p>
                        <div className="flex items-center gap-3 mt-2" data-id="element-119">
                          <div className="flex items-center gap-2 bg-gray-50/50 rounded-md p-1 border border-gray-100" data-id="element-120">
                            <button onClick={() => handleQuantityChange(item.name, -1)} className="w-6 h-6 rounded flex items-center justify-center bg-white text-[#1A1A1A] shadow-sm hover:bg-gray-50 border border-gray-200" data-id="element-121">
                              <Minus className="w-3 h-3" data-id="element-122" />
                            </button>
                            <span className="w-4 text-center text-sm font-medium text-[#1A1A1A]" data-id="element-123">
                              {item.quantity}
                            </span>
                            <button onClick={() => handleQuantityChange(item.name, 1)} className="w-6 h-6 rounded bg-white text-[#1A1A1A] shadow-sm hover:bg-gray-50 border border-gray-200 flex items-center justify-center" data-id="element-124">
                              <Plus className="w-3 h-3" data-id="element-125" />
                            </button>
                          </div>
                          <button onClick={() => handleQuantityChange(item.name, -item.quantity)} className="text-xs text-red-500 hover:text-red-600 flex items-center gap-1 ml-auto" data-id="element-126">
                            <Trash2 className="w-3.5 h-3.5" data-id="element-127" />
                            Ta bort
                          </button>
                        </div>
                      </div>
                    </motion.div>)}
              </div>

              <div className="p-6 border-t border-[#7C8062]/15 bg-[#F2EDE4]/30 space-y-4 overflow-y-auto max-h-[60vh]" data-id="element-128">
                {/* Företag / Privatperson */}
                <div className="space-y-1.5" data-id="element-129">
                  <label className="block text-xs font-medium text-[#1A1A1A]/70" data-id="element-130">
                    Kundtyp
                  </label>
                  <div className="flex items-center bg-white p-1 rounded-lg border border-[#7C8062]/15" data-id="element-131">
                    <button onClick={() => setCustomerType('företag')} className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all ${customerType === 'företag' ? 'bg-[#F2EDE4] text-[#1A1A1A] shadow-sm border border-[#7C8062]/15' : 'text-[#1A1A1A]/60 hover:text-[#1A1A1A]'}`} data-id="element-132">
                      🏢 Företag
                    </button>
                    <button onClick={() => {
                  setCustomerType('privatperson');
                  setDeliveryType('avhämtning');
                }} className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all ${customerType === 'privatperson' ? 'bg-[#F2EDE4] text-[#1A1A1A] shadow-sm border border-[#7C8062]/15' : 'text-[#1A1A1A]/60 hover:text-[#1A1A1A]'}`} data-id="element-133">
                      👤 Privatperson
                    </button>
                  </div>
                  {customerType === 'privatperson' && <div className="flex items-start gap-2 p-2.5 bg-[#F2EDE4]/20 rounded-lg border border-[#7C8062]/10 text-xs text-[#1A1A1A]/70" data-id="element-134">
                      <span className="text-base leading-none mt-px" data-id="element-135">💳</span>
                      <span data-id="element-136">
                        Privatpersoner betalar på plats vid avhämtning.
                        Utkörning är inte tillgängligt för privatpersoner.
                      </span>
                    </div>}
                </div>

                {/* Kontaktuppgifter */}
                <div className="space-y-3 p-3 bg-white rounded-xl border border-[#7C8062]/15" data-id="element-137">
                  <p className="text-xs font-medium text-[#7C8062]" data-id="element-138">
                    {customerType === 'företag' ? '🏢 Företagsuppgifter' : '👤 Dina uppgifter'}
                  </p>
                  {customerType === 'företag' && <>
                      <div data-id="element-139">
                        <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-140">
                          Företagsnamn *
                        </label>
                        <input type="text" value={companyName} onChange={e => {
                    setCompanyName(e.target.value);
                    setFieldErrors(prev => {
                      const n = {
                        ...prev
                      };
                      delete n.companyName;
                      return n;
                    });
                  }} placeholder="Företagets namn" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.companyName ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-141" />
                        {fieldErrors.companyName && <p className="text-xs text-red-500 mt-1" data-id="element-142">
                            {fieldErrors.companyName}
                          </p>}
                      </div>
                      <div data-id="element-143">
                        <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-144">
                          Organisationsnummer *
                        </label>
                        <input type="text" value={orgNumber} onChange={e => {
                    setOrgNumber(e.target.value);
                    setFieldErrors(prev => {
                      const n = {
                        ...prev
                      };
                      delete n.orgNumber;
                      return n;
                    });
                  }} placeholder="XXXXXX-XXXX" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.orgNumber ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-145" />
                        {fieldErrors.orgNumber && <p className="text-xs text-red-500 mt-1" data-id="element-146">
                            {fieldErrors.orgNumber}
                          </p>}
                      </div>
                      <div data-id="element-147">
                        <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-148">
                          Fakturamejl *
                        </label>
                        <input type="email" value={invoiceEmail} onChange={e => {
                    setInvoiceEmail(e.target.value);
                    setFieldErrors(prev => {
                      const n = {
                        ...prev
                      };
                      delete n.invoiceEmail;
                      return n;
                    });
                  }} placeholder="faktura@foretag.se" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.invoiceEmail ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-149" />
                        {fieldErrors.invoiceEmail && <p className="text-xs text-red-500 mt-1" data-id="element-150">
                            {fieldErrors.invoiceEmail}
                          </p>}
                      </div>
                      <div data-id="element-151">
                        <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-152">
                          Referens / Kostnadsställe *
                        </label>
                        <input type="text" value={invoiceReference} onChange={e => {
                    setInvoiceReference(e.target.value);
                    setFieldErrors(prev => {
                      const n = {
                        ...prev
                      };
                      delete n.invoiceReference;
                      return n;
                    });
                  }} placeholder="Er referens eller kostnadsställe" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.invoiceReference ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-153" />
                        {fieldErrors.invoiceReference && <p className="text-xs text-red-500 mt-1" data-id="element-154">
                            {fieldErrors.invoiceReference}
                          </p>}
                      </div>
                      <div data-id="element-155">
                        <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-156">
                          Önskemål / Övriga önskemål
                        </label>
                        <textarea value={önskemål} onChange={e => setÖnskemål(e.target.value)} placeholder="Eventuella allergier, specialkost eller andra önskemål..." className="w-full min-h-[80px] p-3 rounded-lg border border-[#7C8062]/15 bg-white focus:border-[#7C8062] focus:ring-2 focus:ring-[#7C8062]/15 outline-none transition-all text-sm resize-y" data-id="element-157" />
                      </div>
                    </>}
                  <div data-id="element-158">
                    <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-159">
                      {customerType === 'företag' ? 'Kontaktperson *' : 'Namn *'}
                    </label>
                    <input type="text" value={contactPerson} onChange={e => {
                  setContactPerson(e.target.value);
                  setFieldErrors(prev => {
                    const n = {
                      ...prev
                    };
                    delete n.contactPerson;
                    return n;
                  });
                }} placeholder={customerType === 'företag' ? 'Kontaktpersonens namn' : 'Ditt för- och efternamn'} className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.contactPerson ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-160" />
                    {fieldErrors.contactPerson && <p className="text-xs text-red-500 mt-1" data-id="element-161">
                        {fieldErrors.contactPerson}
                      </p>}
                  </div>
                  <div className="grid grid-cols-2 gap-2" data-id="element-162">
                    <div data-id="element-163">
                      <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-164">
                        E-post *
                      </label>
                      <input type="email" value={customerEmail} onChange={e => {
                    setCustomerEmail(e.target.value);
                    setFieldErrors(prev => {
                      const n = {
                        ...prev
                      };
                      delete n.customerEmail;
                      return n;
                    });
                  }} placeholder="din@epost.se" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.customerEmail ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-165" />
                      {fieldErrors.customerEmail && <p className="text-xs text-red-500 mt-1" data-id="element-166">
                          {fieldErrors.customerEmail}
                        </p>}
                    </div>
                    <div data-id="element-167">
                      <label className="block text-xs font-medium text-[#7C8062] mb-1" data-id="element-168">
                        Telefon *
                      </label>
                      <input type="tel" value={customerPhone} onChange={e => {
                    setCustomerPhone(e.target.value);
                    setFieldErrors(prev => {
                      const n = {
                        ...prev
                      };
                      delete n.customerPhone;
                      return n;
                    });
                  }} placeholder="070-123 45 67" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.customerPhone ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062] focus:border-[#7C8062] focus:ring-[#7C8062]'}`} data-id="element-169" />
                      {fieldErrors.customerPhone && <p className="text-xs text-red-500 mt-1" data-id="element-170">
                          {fieldErrors.customerPhone}
                        </p>}
                    </div>
                  </div>
                </div>

                {/* Engång / Återkommande */}
                <div className="space-y-1.5" data-id="element-171">
                  <label className="block text-xs font-medium text-[#1A1A1A]/70" data-id="element-172">
                    Ordertyp
                  </label>
                  <div className="flex items-center bg-white p-1 rounded-lg border border-[#7C8062]/15" data-id="element-173">
                    <button onClick={() => setOrderFrequency('engång')} className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all ${orderFrequency === 'engång' ? 'bg-[#F2EDE4] text-[#1A1A1A] shadow-sm border border-[#7C8062]/15' : 'text-[#1A1A1A]/60 hover:text-[#1A1A1A]'}`} data-id="element-174">
                      Engångsbeställning
                    </button>
                    <button onClick={() => setOrderFrequency('återkommande')} className={`flex-1 flex items-center justify-center gap-2 px-3 py-2 rounded-md text-sm font-medium transition-all ${orderFrequency === 'återkommande' ? 'bg-[#F2EDE4] text-[#1A1A1A] shadow-sm border border-[#7C8062]/15' : 'text-[#1A1A1A]/60 hover:text-[#1A1A1A]'}`} data-id="element-175">
                      Återkommande
                    </button>
                  </div>
                  {orderFrequency === 'återkommande' && <div className="space-y-3 p-3 bg-white rounded-xl border border-[#7C8062]/15 mt-2" data-id="element-176">
                      <p className="text-xs font-medium text-[#7C8062] flex items-center gap-1.5" data-id="element-177">
                        🔄 Hur ofta vill ni ha leverans?
                      </p>

                      <div className="flex gap-2" data-id="element-178">
                        {(['veckovis', 'månadsvis', 'annat'] as const).map(type => <button key={type} onClick={() => setRecurringType(type)} className={`flex-1 px-3 py-2 rounded-lg text-xs font-medium transition-all ${recurringType === type ? 'bg-[#F2EDE4] text-[#1A1A1A] border border-[#7C8062]/15 shadow-sm' : 'bg-gray-50 text-[#1A1A1A]/60 border border-transparent hover:bg-gray-100'}`} data-id="element-179">
                              {type === 'veckovis' ? '📅 Veckovis' : type === 'månadsvis' ? '🗓️ Månadsvis' : '✏️ Annat'}
                            </button>)}
                      </div>

                      {recurringType === 'veckovis' && <div className="space-y-2" data-id="element-180">
                          <label className="block text-xs font-medium text-[#1A1A1A]/70" data-id="element-181">
                            Vilka veckodagar?
                          </label>
                          <div className="grid grid-cols-3 gap-1.5" data-id="element-182">
                            {['Måndag', 'Tisdag', 'Onsdag', 'Torsdag', 'Fredag', 'Lördag'].map(day => <button key={day} onClick={() => toggleWeekday(day)} className={`px-2 py-2 rounded-lg text-xs font-medium transition-all ${selectedWeekdays.includes(day) ? 'bg-[#7C8062] text-white shadow-sm' : 'bg-gray-50 text-[#1A1A1A]/70 border border-gray-200 hover:bg-gray-100'}`} data-id="element-183">
                                {day.slice(0, 3)}
                              </button>)}
                          </div>
                          {selectedWeekdays.length > 0 && <p className="text-xs text-[#1A1A1A]/50 italic" data-id="element-184">
                              Valda: {selectedWeekdays.join(', ')}
                            </p>}
                        </div>}

                      {recurringType === 'månadsvis' && <div className="space-y-2" data-id="element-185">
                          <label className="block text-xs font-medium text-[#1A1A1A]/70" data-id="element-186">
                            Vilka datum i månaden?
                          </label>
                          <div className="grid grid-cols-7 gap-1" data-id="element-187">
                            {Array.from({
                      length: 31
                    }, (_, i) => i + 1).map(date => <button key={date} onClick={() => toggleMonthDate(date)} className={`w-full aspect-square rounded-md text-xs font-medium transition-all flex items-center justify-center ${selectedMonthDates.includes(date) ? 'bg-[#7C8062] text-white shadow-sm' : 'bg-gray-50 text-[#1A1A1A]/70 hover:bg-gray-100'}`} data-id="element-188">
                                {date}
                              </button>)}
                          </div>
                          {selectedMonthDates.length > 0 && <p className="text-xs text-[#1A1A1A]/50 italic" data-id="element-189">
                              Valda datum:{' '}
                              {selectedMonthDates.sort((a, b) => a - b).join(', ')}
                            </p>}
                        </div>}

                      {recurringType === 'annat' && <div className="space-y-2" data-id="element-190">
                          <label className="block text-xs font-medium text-[#1A1A1A]/70" data-id="element-191">
                            Beskriv önskat upplägg
                          </label>
                          <textarea value={recurringNote} onChange={e => setRecurringNote(e.target.value)} placeholder="T.ex. varannan vecka på tisdagar, första och tredje fredagen varje månad..." className="w-full min-h-[70px] p-3 rounded-lg border border-[#7C8062]/15 bg-white focus:border-[#7C8062] focus:ring-2 focus:ring-[#7C8062]/15 outline-none transition-all text-sm resize-y" data-id="element-192" />
                        </div>}

                      <p className="text-xs text-[#1A1A1A]/50 bg-[#F2EDE4]/20 p-2 rounded-md border border-[#7C8062]/10" data-id="element-193">
                        Vi bekräftar schemat i vår offert och anpassar efter era
                        önskemål.
                      </p>
                    </div>}
                </div>

                {/* Datum & Tidsintervall */}
                <div className="space-y-2" data-id="element-194">
                  <label className="block text-xs font-medium text-[#1A1A1A]/70" data-id="element-195">
                    {orderFrequency === 'återkommande' ? 'Önskat startdatum' : 'Datum'}
                  </label>
                  <div className="relative" data-id="element-196">
                    <input type="date" value={orderDate} onChange={e => {
                  setOrderDate(e.target.value);
                  setFieldErrors(prev => {
                    const n = {
                      ...prev
                    };
                    delete n.orderDate;
                    return n;
                  });
                }} className={`w-full h-10 pl-10 pr-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.orderDate ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-197" />
                    <Calendar className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#1A1A1A]/40 pointer-events-none" data-id="element-198" />
                  </div>
                  {fieldErrors.orderDate && <p className="text-xs text-red-500 mt-1" data-id="element-199">
                      {fieldErrors.orderDate}
                    </p>}
                </div>

                <div className="space-y-2" data-id="element-200">
                  <label className="block text-xs font-medium text-[#1A1A1A]/70" data-id="element-201">
                    Tid (från - till)
                  </label>
                  <div className="flex items-center gap-2" data-id="element-202">
                    <div className="relative flex-1" data-id="element-203">
                      <input type="time" value={orderTime} onChange={e => {
                    setOrderTime(e.target.value);
                    setFieldErrors(prev => {
                      const n = {
                        ...prev
                      };
                      delete n.orderTime;
                      return n;
                    });
                  }} className={`w-full h-10 pl-10 pr-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.orderTime ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-204" />
                      <Clock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#1A1A1A]/40 pointer-events-none" data-id="element-205" />
                    </div>
                    <span className="text-[#1A1A1A]/40" data-id="element-206">-</span>
                    <div className="relative flex-1" data-id="element-207">
                      <input type="time" value={orderTimeTo} onChange={e => setOrderTimeTo(e.target.value)} className="w-full h-10 pl-10 pr-3 rounded-lg border border-[#7C8062]/15 bg-white focus:border-[#7C8062] focus:ring-2 focus:ring-[#7C8062]/15 outline-none transition-all text-sm" data-id="element-208" />
                      <Clock className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-[#1A1A1A]/40 pointer-events-none" data-id="element-209" />
                    </div>
                  </div>
                  {fieldErrors.orderTime && <p className="text-xs text-red-500 mt-1" data-id="element-210">
                      {fieldErrors.orderTime}
                    </p>}
                  <div className="flex items-center gap-2 mt-2" data-id="element-211">
                    <input type="checkbox" id="exactTime" checked={exactTime} onChange={e => setExactTime(e.target.checked)} className="rounded border-[#7C8062]/20 text-[#7C8062] focus:ring-[#7C8062]" data-id="element-212" />
                    <label htmlFor="exactTime" className="text-xs text-[#1A1A1A]/70" data-id="element-213">
                      Detta är en exakt tid (ej flexibel)
                    </label>
                  </div>
                </div>

                {/* Leveransadress */}
                {customerType === 'företag' && deliveryType === 'upphämtning' && <div className="space-y-3 p-3 bg-white rounded-xl border border-[#7C8062]/15" data-id="element-214">
                      <p className="text-xs font-medium text-[#7C8062]" data-id="element-215">
                        🚚 Leveransadress
                      </p>
                      <div data-id="element-216">
                        <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-217">
                          Gatuadress *
                        </label>
                        <input type="text" value={deliveryStreet} onChange={e => {
                  setDeliveryStreet(e.target.value);
                  setFieldErrors(prev => {
                    const n = {
                      ...prev
                    };
                    delete n.deliveryStreet;
                    return n;
                  });
                }} placeholder="Gatunamn 1" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.deliveryStreet ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-218" />
                        {fieldErrors.deliveryStreet && <p className="text-xs text-red-500 mt-1" data-id="element-219">
                            {fieldErrors.deliveryStreet}
                          </p>}
                      </div>
                      <div className="grid grid-cols-2 gap-2" data-id="element-220">
                        <div data-id="element-221">
                          <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-222">
                            Postnummer *
                          </label>
                          <input type="text" value={deliveryPostalCode} onChange={e => {
                    setDeliveryPostalCode(e.target.value);
                    setFieldErrors(prev => {
                      const n = {
                        ...prev
                      };
                      delete n.deliveryPostalCode;
                      return n;
                    });
                  }} placeholder="123 45" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.deliveryPostalCode ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-223" />
                          {fieldErrors.deliveryPostalCode && <p className="text-xs text-red-500 mt-1" data-id="element-224">
                              {fieldErrors.deliveryPostalCode}
                            </p>}
                        </div>
                        <div data-id="element-225">
                          <label className="block text-xs font-medium text-[#1A1A1A]/70 mb-1" data-id="element-226">
                            Ort *
                          </label>
                          <input type="text" value={deliveryCity} onChange={e => {
                    setDeliveryCity(e.target.value);
                    setFieldErrors(prev => {
                      const n = {
                        ...prev
                      };
                      delete n.deliveryCity;
                      return n;
                    });
                  }} placeholder="Stad" className={`w-full h-10 px-3 rounded-lg border bg-white focus:ring-2 outline-none transition-all text-sm ${fieldErrors.deliveryCity ? 'border-red-400 focus:border-red-500 focus:ring-red-200' : 'border-[#7C8062]/15 focus:border-[#7C8062] focus:ring-[#7C8062]/15'}`} data-id="element-227" />
                          {fieldErrors.deliveryCity && <p className="text-xs text-red-500 mt-1" data-id="element-228">
                              {fieldErrors.deliveryCity}
                            </p>}
                        </div>
                      </div>
                    </div>}
              </div>

              <div className="p-6 border-t border-[#7C8062]/15 bg-white" data-id="element-229">
                {submitError && <div className="mb-4 p-3 bg-red-50 border border-red-200 rounded-lg text-sm text-red-600" data-id="element-230">
                    {submitError}
                  </div>}
                {isSubmitted ? <div className="text-center space-y-3" data-id="element-231">
                    <div className="w-12 h-12 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-2" data-id="element-232">
                      <span className="text-2xl" data-id="element-233">✓</span>
                    </div>
                    <h3 className="text-lg font-serif text-[#1A1A1A]" data-id="element-234">
                      Förfrågan skickad!
                    </h3>
                    <p className="text-sm text-[#1A1A1A]/70" data-id="element-235">
                      Vi återkommer till er inom kort med en bekräftelse.
                    </p>
                    <Button onClick={() => {
                setIsSubmitted(false);
                setIsCartOpen(false);
                setQuantities({});
              }} className="w-full mt-4" data-id="element-236">
                      Stäng
                    </Button>
                  </div> : <Button onClick={handleContinue} isLoading={isSubmitting} className="w-full py-4 text-base shadow-sm" data-id="element-237">
                    Skicka förfrågan
                  </Button>}
              </div>
            </motion.div>
          </>}
      </AnimatePresence>

      {/* Nutritional Info Modal */}
      <AnimatePresence data-id="element-238">
        {selectedProduct && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm" onClick={() => setSelectedProduct(null)} data-id="element-239">
            <motion.div initial={{
          scale: 0.95,
          opacity: 0,
          y: 20
        }} animate={{
          scale: 1,
          opacity: 1,
          y: 0
        }} exit={{
          scale: 0.95,
          opacity: 0,
          y: 20
        }} onClick={e => e.stopPropagation()} className="bg-white rounded-2xl shadow-2xl w-full max-w-3xl overflow-hidden flex flex-col md:flex-row" data-id="element-240">
              <div className="w-full md:w-1/2 h-64 md:h-auto relative" data-id="element-241">
                <img src={selectedProduct.image} alt={selectedProduct.name} className="w-full h-full object-cover" data-id="element-242" />
              </div>

              <div className="w-full md:w-1/2 p-6 md:p-8 flex flex-col" data-id="element-243">
                <div className="flex justify-between items-start mb-6" data-id="element-244">
                  <h3 className="text-2xl font-serif text-[#1A1A1A] pr-8" data-id="element-245">
                    {selectedProduct.name}
                  </h3>
                  <button onClick={() => setSelectedProduct(null)} className="p-2 -mr-2 -mt-2 text-gray-400 hover:text-[#1A1A1A] hover:bg-gray-100 rounded-full transition-colors" data-id="element-246">
                    <X className="w-5 h-5" data-id="element-247" />
                  </button>
                </div>

                <div className="flex-1 space-y-6" data-id="element-248">
                  <div className="bg-[#F2EDE4] p-4 rounded-xl border border-[#7C8062]/15" data-id="element-249">
                    <h4 className="text-sm font-medium text-[#1A1A1A] mb-2 flex items-center gap-2" data-id="element-250">
                      <Info className="w-4 h-4 text-[#7C8062]" data-id="element-251" />
                      Om produkten
                    </h4>
                    <p className="text-sm text-[#1A1A1A]/80 leading-relaxed" data-id="element-252">
                      {selectedProduct.description}
                    </p>
                  </div>

                  <div data-id="element-253">
                    <h4 className="text-sm font-medium text-[#1A1A1A] mb-2" data-id="element-254">
                      Allergener
                    </h4>
                    <div className="flex flex-wrap gap-2" data-id="element-255">
                      <span className="px-2.5 py-1 bg-gray-100 text-gray-700 text-xs rounded-md font-medium" data-id="element-256">
                        Gluten
                      </span>
                      <span className="px-2.5 py-1 bg-gray-100 text-gray-700 text-xs rounded-md font-medium" data-id="element-257">
                        Laktosfritt smör & grädde i grunden
                      </span>
                      <span className="px-2.5 py-1 bg-gray-100 text-gray-700 text-xs rounded-md font-medium" data-id="element-258">
                        Kan innehålla spår av nötter
                      </span>
                    </div>
                    <p className="text-xs text-[#1A1A1A]/50 mt-2 italic" data-id="element-259">
                      Observera att vissa fyllningar kan innehålla vanlig
                      laktos.
                    </p>
                  </div>
                </div>

                <div className="mt-8 pt-6 border-t border-gray-100 flex items-center justify-between" data-id="element-260">
                  <div className="flex items-center gap-3 bg-gray-50 rounded-lg p-1.5 border border-gray-200" data-id="element-261">
                    <button onClick={() => handleQuantityChange(selectedProduct.name, -1)} disabled={!quantities[selectedProduct.name]} className={`w-10 h-10 rounded-md flex items-center justify-center transition-colors ${quantities[selectedProduct.name] ? 'bg-white text-[#1A1A1A] shadow-sm hover:bg-gray-100 border border-gray-200' : 'text-gray-300 cursor-not-allowed'}`} data-id="element-262">
                      <Minus className="w-5 h-5" data-id="element-263" />
                    </button>
                    <span className="w-8 text-center font-medium text-[#1A1A1A] text-lg" data-id="element-264">
                      {quantities[selectedProduct.name] || 0}
                    </span>
                    <button onClick={() => handleQuantityChange(selectedProduct.name, 1)} className="w-10 h-10 rounded-md bg-white text-[#1A1A1A] shadow-sm hover:bg-gray-100 border border-gray-200 flex items-center justify-center transition-colors" data-id="element-265">
                      <Plus className="w-5 h-5" data-id="element-266" />
                    </button>
                  </div>

                  <Button onClick={() => setSelectedProduct(null)} data-id="element-267">Klar</Button>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </section>;
}